import { render } from "./NerpathamList.vue?vue&type=template&id=3fc1aefd&scoped=true"
import script from "./NerpathamList.vue?vue&type=script&lang=js"
export * from "./NerpathamList.vue?vue&type=script&lang=js"

import "./NerpathamList.vue?vue&type=style&index=0&id=3fc1aefd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc1aefd"]])

export default __exports__